function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M15.547 10.345c.57 0 1.035-.464 1.035-1.035h-2.07c0 .57.465 1.035 1.035 1.035z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M11.926 25.862a.517.517 0 1 1 0-1.033.517.517 0 0 1 0 1.033z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M4.168 24.828h4.138v1.034H4.168z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M6.237 10.345c.57 0 1.034-.464 1.034-1.035H5.202c0 .57.464 1.035 1.035 1.035z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M.03 0v2.372L2.402 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M28.767 19.614l.158-1.423a6.208 6.208 0 0 1-4.068-1.06v3.48l.475 1.537h1.594a.516.516 0 0 1 .315.928l-1.312 1.002.504 1.631a.518.518 0 0 1-.808.564l-.767-.586v4.066a9.34 9.34 0 0 0 5.112-5.36 7.018 7.018 0 0 1-1.203-4.78z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M15.547 6.846l-.715 1.43h1.43z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M22.446 26.286a.517.517 0 0 1-.198-.577l.504-1.631-1.312-1.002a.516.516 0 0 1 .314-.928h1.594l.475-1.537v-3.48a6.224 6.224 0 0 1-4.068 1.06l.158 1.423a7.015 7.015 0 0 1-1.203 4.78 9.342 9.342 0 0 0 5.113 5.36v-4.067l-.768.586a.517.517 0 0 1-.61.013z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M24.834 24.04a.517.517 0 0 1 .18-.565l.384-.292h-.447a.518.518 0 0 1-.495-.364l-.116-.377-.116.377a.517.517 0 0 1-.495.364h-.446l.383.292a.518.518 0 0 1 .18.564l-.132.43.312-.239a.516.516 0 0 1 .628 0l.313.239z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M17.642 24.474a10.356 10.356 0 0 0 3.078 4.564V30H.03V6.42L6.45 0h14.27v17.165a5.127 5.127 0 0 1-1.25-.053l-.892-.149.307 2.765A5.993 5.993 0 0 1 17.72 24l-.163.217zm-.026-2.75h-7.241v1.035h7.241zm0-4.138h-7.241v1.035h7.241zM4.168 9.31c0 1.141.928 2.07 2.069 2.07a2.071 2.071 0 0 0 2.069-2.07v-.639L7.074 6.207h3.3v6.207H8.307v1.034h5.172v-1.034H11.41V6.207h3.301L13.478 8.67v.64c0 1.14.928 2.068 2.07 2.068a2.071 2.071 0 0 0 2.068-2.069v-.639l-1.75-3.499H11.41V3.103h-1.034v2.07H5.917L4.167 8.67zm-1.035 7.242h14.483v-1.035H3.133zm0 2.069H9.34v-1.035H3.133zm0 2.069h14.483v-1.035H3.133zm6.207 3.103H3.133v3.104H9.34zm0-2.069H3.133v1.035H9.34zm4.138 3.62c0-.855-.696-1.551-1.552-1.551-.855 0-1.551.696-1.551 1.552 0 .855.696 1.552 1.551 1.552.856 0 1.552-.697 1.552-1.552zm4.138 0c0-.855-.696-1.551-1.552-1.551-.855 0-1.551.696-1.551 1.552 0 .855.696 1.552 1.551 1.552.856 0 1.552-.697 1.552-1.552z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M3.865 0L.03 3.835v1.123L4.988 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M6.237 6.846l-.715 1.43h1.43z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M16.064 25.862a.517.517 0 1 1 0-1.033.517.517 0 0 1 0 1.033z"
})))));

var SvgIconCases = function SvgIconCases(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCases, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cases.92a2c10b.svg";
export { ForwardRef as ReactComponent };